// پارسه — balance, price list, top-up, gift codes, the ledger.
export const credits = {
  // ── پارسه — the wallet ───────────────────────────────────────────────
  'credits.title': 'پارسه',
  'credits.sub': 'اعتبار پارسینا برای دستیار. هر پاسخ مقداری از آن خرج می‌کند.',
  'credits.balance.label': 'موجودی شما',
  'credits.balance.loading': 'در حال خواندن موجودی…',
  'credits.free.title': 'هر ماه ۵۰۰ پارسه رایگان',
  'credits.free.body': 'ابتدای هر ماه تمدید می‌شود، چه شارژ کنید چه نکنید.',
  'credits.priceList.title': 'هزینهٔ هر عملیات',
  'credits.price.ask': 'پرسش از دستیار',
  'credits.price.differential': 'تشخیص افتراقی',
  'credits.price.soap': 'پیشنهاد SOAP',
  'credits.price.orders': 'پیشنهاد دستورات',
  'credits.price.interaction': 'بررسی تداخل دارویی',
  'credits.price.voice': 'ورود صوتی',
  'credits.topUp.title': 'شارژ اعتبار',
  'credits.topUp.action': 'خرید پارسه',
  'credits.topUp.recommended': 'پیشنهادی',
  'credits.topUp.custom': 'مبلغ دلخواه',
  'credits.topUp.customLabel': 'مبلغ به تومان',
  'credits.topUp.pay': 'پرداخت {{amount}} تومان از طریق {{gateway}}',
  'credits.topUp.redirecting': 'در حال انتقال به درگاه بانک…',
  'credits.topUp.min': 'کمترین مبلغ خرید {{amount}} تومان است.',
  'credits.topUp.note': 'برای پرداخت به صفحهٔ خودِ بانک منتقل می‌شوید.',
  'credits.topUp.failed': 'شروع پرداخت ممکن نشد.',
  'credits.gateway.saderat': 'صادرات (سپهر)',
  'credits.gateway.zarinpal': 'زرین‌پال',
  'credits.gift.title': 'کد هدیه',
  'credits.gift.hint': 'کدی از کمپین‌های پارسینا دارید؟ اینجا استفاده کنید.',
  'credits.gift.placeholder': 'PARSINA-XXXX',
  'credits.gift.submit': 'استفاده از کد',
  'credits.gift.submitting': 'در حال بررسی…',
  'credits.gift.empty': 'ابتدا کد را وارد کنید.',
  'credits.gift.notFound': 'این کد معتبر نیست.',
  'credits.gift.success': '{{parseh}} پارسه اضافه شد.',
  'credits.gift.newBalance': 'موجودی جدید',
  'credits.gift.oneUse': 'هر کد فقط یک بار قابل استفاده است.',
  'credits.gift.myCodes': 'کدهایی که استفاده کرده‌اید',
  'credits.gift.worth': 'ارزش: {{parseh}} پارسه',
  'credits.gift.status.issued': 'استفاده‌نشده',
  'credits.gift.status.redeemed': 'استفاده‌شده',
  'credits.gift.status.revoked': 'باطل‌شده',
  'credits.gift.status.expired': 'منقضی',
  'credits.tx.title': 'گردش حساب',
  'credits.tx.empty.title': 'هنوز گردشی ثبت نشده',
  'credits.tx.empty.body': 'خرج‌ها و شارژهای شما اینجا نمایش داده می‌شود.',
  'credits.tx.error.title': 'گردش حساب بارگذاری نشد',
  'credits.tx.columns.date': 'زمان',
  'credits.tx.columns.service': 'بابت',
  'credits.tx.columns.description': 'توضیح',
  'credits.tx.columns.amount': 'پارسه',
  'credits.tx.filter.all': 'همه',
  'credits.tx.filter.credit': 'افزوده',
  'credits.tx.filter.debit': 'خرج‌شده',
  'credits.service.ask': 'پرسش از دستیار',
  'credits.service.differential': 'تشخیص افتراقی',
  'credits.service.interaction': 'بررسی تداخل',
  'credits.service.transcription': 'تبدیل گفتار به متن',
  'credits.service.gift': 'کد هدیه',
  'credits.service.topup': 'شارژ',
  'credits.service.sms': 'پیامک',
  'credits.service.other': 'امکان هوشمند',
};

export default credits;
